import type { LensCardView, LensDataset } from '~/types/leLens';

/** A calculated field is a column as far as a card is concerned. */
export function readableColumns(dataset: LensDataset): Array<string> {
  return [
    ...(dataset.columns ?? []).map((column) => column.name),
    ...(dataset.fields ?? []).map((field) => field.name),
  ];
}

export function columnsTheViewReads(view: LensCardView | undefined): Array<string> {
  if (!view) {
    return [];
  }
  return [view.x, view.series, view.value, ...(view.values ?? []), view.ratio?.of, view.ratio?.per].filter(
    (column): column is string => Boolean(column),
  );
}

/** A column the SQL never names cannot be one it returns; the converse does not hold. */
export function sqlCouldReturn(sql: string, columns: ReadonlyArray<string>): boolean {
  const named = new Set(sql.match(/[A-Za-z_][A-Za-z0-9_]*/g) ?? []);
  return columns.every((column) => named.has(column));
}

export function viewHoldsOn(view: LensCardView | undefined, dataset: LensDataset): boolean {
  if (!view) {
    return false;
  }
  if (!dataset.columns) {
    return true;
  }
  const known = new Set(readableColumns(dataset));
  // An aggregate is either one of the named reducers or a calculated field.
  const named = [...columnsTheViewReads(view), ...(known.has(view.aggregate ?? '') ? [view.aggregate] : [])];
  return named.every((column) => !column || known.has(column));
}
